import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App3 } from './App3';
const root = createRoot(document.getElementById('root')!);
root.render(<App3 data-id="element-1042" />);